// import AOS from 'aos';
import 'picturefill';
import fitVids from 'fitvids';
import 'slick-carousel';
import 'flexslider';
import './lib/css3-animated';
import 'parsleyjs';
import 'magnific-popup';
// import hljs from 'highlight.js';
// import 'highlight.js/styles/github.css';
import 'aria-modal-dialog';
// import './pages/contact';

// CREATE HTML5 ELEMENTS FOR OLD BROWSERS
document.createElement('article');
document.createElement('aside');
document.createElement('figure');
document.createElement('footer');
document.createElement('header');
document.createElement('main');
document.createElement('nav');
document.createElement('section');
document.createElement('time');

// PLACEHOLDERS
(function (f, h, $) { var a = 'placeholder' in h.createElement('input'), d = 'placeholder' in h.createElement('textarea'), i = $.fn, c = $.valHooks, k, j; if (a && d) { j = i.placeholder = function () { return this }; j.input = j.textarea = true } else { j = i.placeholder = function () { var l = this; l.filter((a ? 'textarea' : ':input') + '[placeholder]').not('.placeholder').bind({ 'focus.placeholder': b, 'blur.placeholder': e }).data('placeholder-enabled', true).trigger('blur.placeholder'); return l }; j.input = a; j.textarea = d; k = { get: function (m) { var l = $(m); return l.data('placeholder-enabled') && l.hasClass('placeholder') ? '' : m.value }, set: function (m, n) { var l = $(m); if (!l.data('placeholder-enabled')) { return m.value = n } if (n == '') { m.value = n; if (m != h.activeElement) { e.call(m) } } else { if (l.hasClass('placeholder')) { b.call(m, true, n) || (m.value = n) } else { m.value = n } } return l } }; a || (c.input = k); d || (c.textarea = k); $(function () { $(h).delegate('form', 'submit.placeholder', function () { var l = $('.placeholder', this).each(b); setTimeout(function () { l.each(e) }, 10) }) }); $(f).bind('beforeunload.placeholder', function () { $('.placeholder').each(function () { this.value = '' }) }) } function g(m) { var l = {}, n = /^jQuery\d+$/; $.each(m.attributes, function (p, o) { if (o.specified && !n.test(o.name)) { l[o.name] = o.value } }); return l } function b(m, n) { var l = this, o = $(l); if (l.value == o.attr('placeholder') && o.hasClass('placeholder')) { if (o.data('placeholder-password')) { o = o.hide().next().show().attr('id', o.removeAttr('id').data('placeholder-id')); if (m === true) { return o[0].value = n } o.focus() } else { l.value = ''; o.removeClass('placeholder'); l == h.activeElement && l.select() } } } function e() { var q, l = this, p = $(l), m = p, o = this.id; if (l.value == '') { if (l.type == 'password') { if (!p.data('placeholder-textinput')) { try { q = p.clone().attr({ type: 'text' }) } catch (n) { q = $('<input>').attr($.extend(g(this), { type: 'text' })) } q.removeAttr('name').data({ 'placeholder-password': true, 'placeholder-id': o }).bind('focus.placeholder', b); p.data({ 'placeholder-textinput': q, 'placeholder-id': o }).before(q) } p = p.removeAttr('id').hide().prev().attr('id', o).show() } p.addClass('placeholder'); p[0].value = p.attr('placeholder') } else { p.removeClass('placeholder') } } }(this, document, jQuery));

// OPEN .PDF'S AND EXTERNAL LINKS IN A NEW WINDOW
function buildExternal() {
	$('a[href^="http:"], a[href^="https:"]').not('[href*="' + document.domain + '"]').attr('target', '_blank').attr('rel', 'noopener noreferrer');
	$('a[href$=".pdf"]').attr('target', '_blank');
}

// Custom event handler for HighlightJS
// document.addEventListener('DOMContentLoaded', (event) => {
// 	document.querySelectorAll('pre.code').forEach((block) => {
// 		hljs.highlightBlock(block);
// 	});
// });

$(function () {

	if (typeof console === "undefined") {
		console = { log: function () { } };
	}

	var $ = jQuery;

	var CT = {

		ui: function () {

			// initialize highlight.js
			// hljs.initHighlighting();

			// Animate on Scroll
			// AOS.init({
			// 	offset: -200,
			// 	duration: 600,
			// 	once: true
			// });

			// Fixed Header
			// $(window).scroll(function () {
			// 	if ($(window).scrollTop() >= 1) {
			// 		$('header.top').addClass('fixed');
			// 	}
			// 	else {
			// 		$('header.top').removeClass('fixed');
			// 	}
			// });

			// REPLACE ALL SVG IMAGES WITH INLINE SVG
			// replace <img src=“this.svg”> with SVG code (some SVG images uploaded through CMS)
			if ($('img.svg').length > 0) {
				$('img.svg').each(function () {
					var $img = jQuery(this);
					var imgID = $img.attr('id');
					var imgClass = $img.attr('class');
					var imgURL = $img.attr('src');
					jQuery.get(imgURL, function (data) {
						// Get the SVG tag, ignore the rest
						var $svg = jQuery(data).find('svg');
						// Add replaced image's ID to the new SVG
						if (typeof imgID !== 'undefined') {
							$svg = $svg.attr('id', imgID);
						}
						// Add replaced image's classes to the new SVG
						if (typeof imgClass !== 'undefined') {
							$svg = $svg.attr('class', imgClass + ' replaced-svg');
						}
						// Remove any invalid XML tags as per http://validator.w3.org
						$svg = $svg.removeAttr('xmlns:a');
						// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
						if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
							$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
						}
						// Replace image with new SVG
						$img.replaceWith($svg);
					}, 'xml');
				});
			}

			// FITVIDS
			if ($('.fit-vid').length > 0) {
				fitVids('.fit-vid');
			}

			// Parsley Form Validation
			if ($('.form-generic').length > 0) {
				$('.form-generic').parsley();
			}

			// Magnific Popup // -> Used for Banner video modal and form modals
			if ($('.open-modal').length > 0) {
				$('.open-modal').magnificPopup({
					type: 'inline',
					preloader: false,
					focus: '#name, .modal-custom-form .freeform-row .freeform-input, #jw-video',
					// When element is focused, some mobile browsers in some cases zoom in
					// It looks not nice, so we disable it:
					callbacks: {
						beforeOpen: function () {
							if ($(window).width() < 700) {
								this.st.focus = false;
							} else {
								this.st.focus = '#name, .modal-custom-form .freeform-row .freeform-input, #jw-video';
							}
						}
					}
				});

				$('.open-modal').keypress(function (event) {
					if (event.which == 32) {
						event.target.click();
					}
				});

				// Backwards tabbing from 1st field
				const $form = $('.modal-custom-form form');
				const $name = $form.find('#name');
				const $input = $form.find('.freeform-row .freeform-input');
				const $video = $form.find('#jw-video');
				let focusedItem;

				if ($name.length > 0) {
					focusedItem = $name;
				} else if ($input.length > 0) {
					focusedItem = $input.eq(0);
				} else if ($video.length > 0) {
					focusedItem = $video;
				}

				focusedItem.on('keydown', function (event) {
					if (!event.shiftKey || event.keyCode !== 9) {
						return;
					}

					event.preventDefault();
					$('button.mfp-close').focus();
				});
			}

			// Multiple Flexsliders per page -> .carousel
			if ($('.carousel').length > 0) {
				$('.carousel').each(function () {
					let slider = $(this).find('.slider');

					slider.flexslider({
						animation: 'slide',
						slideshow: false,
						customDirectionNav: false,
						controlNav: false,
						selector: '.slides > .slide',
						touch: true,
            smoothHeight: true,
            after: function(){
              window.lazyload.update()
            }
						// useCSS: false,
					});

					$(this).find('.slider-nav-control').flexslider({
						animation: "slide",
						slideshow: false,
						sync: slider,
						manualControls: $(this).find('.slide-control li'),
						controlsContainer: $(this).find('.slider-container'),
						customDirectionNav: $(this).find('.slide-arrows a'),
					});

					$(this).find('.slide.clone').attr('tabIndex', '-1');
				});
			}

			// Switches focus
			$('.switcher').click(function (event) {
				event.preventDefault();
				let list = $(this).data('name');

				$('ul').hide();
				$('#' + list).show();
			});

			// Structure breadcrumb dropdowns
			$('.dropdown-trigger').on('click', function () {
				$('.dropdown').toggle();
			});
			if ($('.breadcrumb-drowndown').length > 0) {
				let breadCrumbDropdown = $('.breadcrumb-drowndown');
				$('.breadcrumb-drowndown').on('click', function (e) {
					e.preventDefault();
					if (!breadCrumbDropdown.hasClass('open')) {
						breadCrumbDropdown.addClass('open');
						breadCrumbDropdown.find('a').attr('aria-expanded', 'true');
						breadCrumbDropdown.find('ul').attr('aria-hidden', 'false');
					} else {
						breadCrumbDropdown.removeClass('open');
						breadCrumbDropdown.find('a').attr('aria-expanded', 'false');
						breadCrumbDropdown.find('ul').attr('aria-hidden', 'true');
					}
				});
				$('.breadcrumb-link').on('click', function (e) {
					// window.location.href = e.originalEvent.path[0].href;
					window.location.href = e.target.href;
				});
			}

			// Location Tiles (toggles)[Contact Page] // no-touchevents
			if ($('.no-touchevents .location-tiles .tile').length > 0) {
				$('.no-touchevents .location-tiles .tile').hover(function () {
					let alreadyOpen = $(this).hasClass('open');
					$('.tile.open').removeClass('open');
					if (!alreadyOpen) {
						$(this).addClass('open');
					}
				});
			}

			// Location Tiles (toggles)[Contact Page] // both no-touchevents and touchevents
			if ($('.location-tiles .tile').length > 0) {
				$('.location-tiles .tile').focus(function () {
					let alreadyOpen = $(this).hasClass('open');
					$('.tile.open').removeClass('open');
					if (!alreadyOpen) {
						$(this).addClass('open');
					}
				});

				$('.location-tiles .tile .button').blur(function () {
					$('.tile.open').removeClass('open');
				});
			}

			// Filters Mobile Dropdown
			if ($('.filters-toggle a').length > 0) {
				$('.filters-toggle a').on('click', function () {
					$('.filters-container').toggle();
					$(this).toggleClass('filters-active');
				});
			}

			// Form submission behaviour modifier
			$('input').on('keydown', function (event) {
				if (event.keyCode === 13) {
					event.preventDefault();
				}
			});

			$('select').on('keydown', function (event) {
				if (event.keyCode === 13) {
					event.preventDefault();
				}
			});

			// OPEN .PDF'S AND EXTERNAL LINKS IN A NEW WINDOW
			buildExternal();

			// PLACEHOLDERS
			if ($('form').length > 0) {
				$('input, textarea').placeholder();
			}

			// AFTER CSS IS LOADED
			setTimeout(function () {
				// CSS Animate It
				if ($('.animatedParent').length > 0) {
					$('.animatedParent').appear();
				}

				// Text Columns - adjust padding if no button exists (in redactor)
				if ($('.text-columns .richtext').length > 0) {
					$('.text-columns .richtext').each(function () {
						if ($('a.button', this).html() == undefined) {
							$(this).addClass('padding-bottom-none');
						}
					});
				}

				// Fixes bug with Flexslider displaying part of the next slide
				if ($('.carousel').length > 0) {
					$(window).trigger('resize');
				}
				// if($('.carousel .slider .slide').length > 0) {
				// 	$('.carousel .slider .slide').resize();
				// }

			}, 500);

			// Trigger animation on focus
			$(document.body).on('focus', '.animatedParent', function (e, $affected) {
				var ele = $(this).find('.animated');
				var parent = $(this);

				if (parent.attr('data-sequence') != undefined) {

					var firstId = $(this).find('.animated:first').attr('data-id');
					var number = firstId;
					var lastId = $(this).find('.animated:last').attr('data-id');

					$(parent).find(".animated[data-id=" + number + "]").addClass('go');
					number++;
					delay = Number(parent.attr('data-sequence'));

					$.doTimeout(delay, function () {
						$(parent).find(".animated[data-id=" + number + "]").addClass('go');
						++number;
						if (number <= lastId) { return true; }
					});
				} else {
					ele.addClass('go');
				}
			});

		},

		init: function () {
			CT.ui();
		}

	};

	CT.init();

});



// WEBPACK FOOTER //
// ./js/main.js